import { CustomFieldAssociatedType, TempFileTypes } from "types/enum";

export function ConvertToTempFileType(cfType: CustomFieldAssociatedType): TempFileTypes {
    switch (cfType) {
        case CustomFieldAssociatedType.Lead:
            return TempFileTypes.Leads;

        case CustomFieldAssociatedType.JobsJobInfo:
            return TempFileTypes.JobSites;

        case CustomFieldAssociatedType.Contacts:
            return TempFileTypes.Contacts;

        case CustomFieldAssociatedType.Warranty:
            return TempFileTypes.Warranty;

        case CustomFieldAssociatedType.ToDos:
            return TempFileTypes.ToDos;

        case CustomFieldAssociatedType.PurchaseOrderPayments:
            return TempFileTypes.POPaymentCustomFieldFiles;

        case CustomFieldAssociatedType.ChangeOrders:
            return TempFileTypes.ChangeOrderDocs;

        case CustomFieldAssociatedType.OwnerPayments:
            return TempFileTypes.OwnerPayments;

        case CustomFieldAssociatedType.DailyLogs:
            return TempFileTypes.DailyLogs;

        case CustomFieldAssociatedType.RFIs:
            return TempFileTypes.RFIs;

        case CustomFieldAssociatedType.Selections:
            return TempFileTypes.Selections;

        case CustomFieldAssociatedType.PurchaseOrders:
            return TempFileTypes.PurchaseOrders;

        case CustomFieldAssociatedType.Subs:
            return TempFileTypes.SubCustomFields;

        case CustomFieldAssociatedType.InternalUsers:
            // TODO: Determine the temp file type
            return TempFileTypes.CustomFieldFiles;

        case CustomFieldAssociatedType.Tasks:
            return TempFileTypes.CustomFieldFiles;

        default:
            throw `Missing switch case in CustomFieldTempFileTypes for CustomFieldAssociatedType: ${cfType}`;
    }
}
